import script from "./terminal-head-remote-actions.vue?vue&type=script&setup=true&lang=ts"
export * from "./terminal-head-remote-actions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__